module.exports = __webpack_public_path__ + "img/Washi-tape-bottom-right.2ab7b866.svg";